<!--
  - SPDX-FileCopyrightText: 2015 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon gpxpod-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 512 512"
			version="1.1"
			viewBox="0 0 512 512"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<g>
				<path d="m250.45 509.25c-18.349-9.169-58.044-54.694-94.123-107.95-45.696-67.447-77.159-132.54-87.231-180.46-3.0862-14.685-3.8582-35.465-1.9093-51.391 5.2805-43.151 24.264-82.157 54.886-112.78 22.014-22.014 47.49-37.669 76.607-47.076 20.072-6.4846 36.328-8.961 58.799-8.9574 15.821 0.0025 25.202 0.87869 38.588 3.6037 29.28 5.9607 57.258 19.102 81.566 38.312 7.1626 5.6605 23.62 22.091 29.148 29.1 27.69 35.11 42.058 75.52 42.114 118.45 0.0195 14.721-1.1704 24.053-5.0755 39.805-11.108 44.805-40.59 104.78-81.745 166.3-43.607 65.182-89.027 115.34-104.45 115.34-1.4232 0-4.6528-1.032-7.1769-2.2933zm17.328-189.49c45.482-4.0255 84.135-30.218 104.51-70.82 14.096-28.09 17.187-60.241 8.7633-91.162-12.359-45.366-50.515-81.408-96.458-91.114-22.979-4.8547-45.101-3.6026-67.459 3.8182-67.122 22.278-103.61 95.091-81.207 162.06 14.257 42.62 49.885 74.724 93.796 84.521 14.096 3.145 24.606 3.8907 38.056 2.7004z" />
				<g>
					<rect x="171.05"
						y="140.76"
						width="41.42"
						height="123.49" />
					<rect x="238.35"
						y="111.61"
						width="41.42"
						height="151.87" />
					<rect x="306.05"
						y="164.73"
						width="41.42"
						height="98.947" />
				</g>
			</g>
		</svg>
	</span>
</template>

<script>
export default {
	name: 'GpxpodIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
	emits: ['click'],
}
</script>
